
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    props: ['data', 'carShowIndex'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const container = ref<any>(null)
        const count = props.data.row * props.data.col

        const render = () => {
            const cars = container.value.querySelectorAll('.car')
            for (let i = 0; i < cars.length; i++) {
                const x = (Math.random() > .5 ? '-' : '+') +  Math.floor(Math.random() * window.innerWidth)
                const y = Math.floor(Math.random() * window.innerWidth)
                const car = cars[i] as HTMLDivElement
                car.style.transform = `translate3d(${x}px, ${y}px, 0)`
            }
        }

        watch(() => props.carShowIndex, (to, from) => {
           
        })
        
        onBeforeUnmount(() => {
            
        })

        onMounted(() => {
            render()
        })    

        return {
            container,
            count
        }
    }
})
